export const DAILY_COST_MONITOR_COMPLETED_EVENT = 'dailyCostMonitorCompleted';
